import { Routes } from '@angular/router';
import { TradableProductsComponent } from './pages/tradable-products.component';

export const TRADABLE_PRODUCTS_WEB_ROUTES: Routes = [{ path: '', component: TradableProductsComponent }];
